import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Button } from 'react-bootstrap';
import ReactHowler from "react-howler";

const GifButton2 = forwardRef((props, ref) => {
  const [playImage, setPlayImage] = useState(false);
  const [sound, setSound] = useState(false);

  function playGifAndSound() {
    setPlayImage(false);
    setPlayImage(true);

    setSound(true);
    setTimeout(() => setSound(false), 2000);

    setTimeout(() => setPlayImage(false), 2000);
  }

  // Expose function to parent via ref
  useImperativeHandle(ref, () => ({
    trigger: playGifAndSound
  }));

  return (
    <Button
      variant=""
      style={{
        border: "none",
        padding: 0,
        background: "transparent",
        boxShadow: "none"
    }}
      className="mt-2 p-0"
      onClick={(e) => {
        e.stopPropagation(); // avoid double-fire
        playGifAndSound();
      }}
    >
      <img
        src={playImage ? props.imageGif : props.imageStatic}
        alt={props.imageAlt}
        style={{ width: "120px", height: "120px" }}
      />
      <ReactHowler src={props.audioVoice} playing={sound} />
    </Button>
  );
});

export default GifButton2;
